module.exports = __webpack_public_path__ + "static/media/c_1.f8a13350.png";